import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Sparkles, Workflow, Plug, FlaskConical, BarChart3, Users, Rocket, Check } from 'lucide-react';
import './AgentStudioTeaser.css';

const features = [
  { icon: Workflow, text: 'Visual agent flow builder' },
  { icon: Plug, text: 'One-click integrations' },
  { icon: FlaskConical, text: 'Live test console' },
  { icon: BarChart3, text: 'Analytics dashboard' },
  { icon: Users, text: 'Team collaboration' },
  { icon: Rocket, text: 'One-click deploy' },
];

export const AgentStudioTeaser = () => {
  const reduced = useReducedMotion();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  };

  return (
    <section className="studio-section">
      <motion.div
        className="studio-card"
        initial={{ opacity: 0, y: reduced ? 0 : 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: reduced ? 0.2 : 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="studio-inner">
          <div className="studio-left">
            <span className="studio-chip">
              <Sparkles size={13} /> Coming Soon
            </span>
            <h2 className="studio-title">Agent Studio</h2>
            <p className="studio-tagline">
              Build and deploy your own AI agents — without writing a single line of code.
            </p>
            <p className="studio-body">
              A visual builder for teams who want to move fast. Design flows, connect integrations,
              test in real time, and deploy in one click — on the same infrastructure behind our
              enterprise deployments.
            </p>

            <form className="studio-form" onSubmit={handleSubmit}>
              {submitted ? (
                <p className="studio-success">
                  <Check size={16} /> You’re on the list. We’ll email you when Agent Studio launches.
                </p>
              ) : (
                <>
                  <label htmlFor="studio-email" className="studio-label">Email address</label>
                  <div className="studio-input-row">
                    <input
                      id="studio-email"
                      type="email"
                      required
                      placeholder="you@company.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="studio-input"
                    />
                    <button type="submit" className="studio-submit">Join Waitlist</button>
                  </div>
                </>
              )}
            </form>
          </div>

          <ul className="studio-features">
            {features.map(({ icon: Icon, text }) => (
              <li key={text} className="studio-feature">
                <Icon size={17} />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </motion.div>
    </section>
  );
};
